// extracted by mini-css-extract-plugin
module.exports = {"openModalBtn":"ChangeClinic_openModalBtn__3zgZA","footer":"ChangeClinic_footer__1gw6Z"};